import { companiesHandler } from '../../services/userProfile/userCompanies.services';
import { createContext } from 'react';
import { profileOperationHandler } from '../../services/userProfile/userProfile.service';

export const CompaniesContext = createContext({});

export const fetchUserProfileCompanies = (
  user,
  callbackFn,
  profileOperationType,
) =>
  companiesHandler({
    params: user,
    callbackFn: callbackFn,
    profileOperationType: profileOperationType,
  });

export const updateCompaniesProfile = (
  data,
  callbackFn,
  profileOperationType,
) => companiesHandler({ data, callbackFn, profileOperationType });

export const saveSocialMediaToken = (
  data,
  callbackFn,
  profileOperationType,
  socialMediaType,
) =>
  companiesHandler({
    data,
    callbackFn,
    profileOperationType,
    socialMediaType,
  });
